import React, { useState } from "react"
import { VisuallyHidden } from "@kit/design/visually-hidden"

export function TipButtons({
  activeTip,
  activeTipBorderColor,
  selectTip,
  tips,
  textColor
}) {
  const [showCustomTipField, setShowCustomTipField] = useState(false)
  const [customTip, setCustomTip] = useState("")

  const sortedTips = [...tips].sort((a, b) => a.amount - b.amount)
  const smallestTip = sortedTips[0]

  function handlePriceClick(tip) {
    selectTip(tip)
    setShowCustomTipField(false)
  }

  function handleOtherAmountClick() {
    selectTip(smallestTip)
    setShowCustomTipField(true)
  }

  function handleCustomTip(e) {
    setCustomTipAmount(e.target.value)
  }

  function setCustomTipAmount(rawTipAmount) {
    setCustomTip(rawTipAmount)
    selectTip({
      id: smallestTip.id,
      amount: (parseFloat(rawTipAmount) * 100).toString(),
      currency: smallestTip.currency,
      currency_display: smallestTip.currency_display
    })
  }

  return (
    <>
      <fieldset>
        <legend
          className="font-semibold"
          style={{ marginBottom: "16px", fontSize: "16px", color: textColor }}
        >
          Choose an amount
        </legend>
        <div className="grid grid-cols-6 gap-3">
          {sortedTips.map(tip => {
            const isSelected = activeTip.id === tip.id && !showCustomTipField
            return (
              <label
                htmlFor={tip.id}
                key={tip.id}
                className="flex font-semibold items-center justify-center text-center border border-solid rounded cursor-pointer"
                style={{
                  color: textColor,
                  fontSize: "14px",
                  height: "40px",
                  minWidth: "58.75px",
                  borderColor: isSelected ? activeTipBorderColor : "#e3e3e3"
                }}
              >
                {tip.formatted.split(".")[0]}
                <input
                  id={tip.id}
                  type="radio"
                  checked={isSelected}
                  onChange={() => handlePriceClick(tip)}
                  value={tip.id}
                  style={{ display: "none" }}
                />
              </label>
            )
          })}

          <label
            htmlFor="otherAmount"
            className="flex font-semibold items-center justify-center text-center border border-solid rounded cursor-pointer col-span-2"
            style={{
              color: textColor,
              fontSize: "14px",
              height: "40px",
              minWidth: "58.75px",
              borderColor: showCustomTipField ? activeTipBorderColor : "#e3e3e3"
            }}
          >
            Other amount
            <input
              id="otherAmount"
              type="radio"
              checked={showCustomTipField}
              onChange={handleOtherAmountClick}
              value="otherAmount"
              style={{ display: "none" }}
            />
          </label>
        </div>
      </fieldset>
      {showCustomTipField && (
        <div className="flex-row w-full relative">
          <VisuallyHidden htmlFor="customTipInput">
            Set your own tip amount
          </VisuallyHidden>
          <input
            id="customTipInput"
            name="custom_tip_amount"
            style={{ marginTop: "16px" }}
            type="number"
            placeholder={`Choose a tip of ${smallestTip.formatted} or more`}
            value={customTip}
            onChange={handleCustomTip}
          />
          <div className="bg-gray-100 justify-center items-center flex formkit-input__append">
            {activeTip.currency_display}
          </div>
        </div>
      )}
    </>
  )
}
